import React from 'react';

export default function SkindrFeatures() {
  const features = [
    {
      id: 1,
      title: "Introduction Screen",
      heading: "Intelligent Speed Detection System",
      description: "The application's introduction screen provides users with an overview of its features and functionalities. A user can also change the language of the app to make it more personalized, allowing them to choose the language they prefer.",
      subDescription: "Whether they prefer Dutch, French, or English, the app accommodates users by providing a seamless language switch option, ensuring that they can navigate and interact with the application comfortably.",
      image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img1.webp",
      reverse: false
    },
    {
      id: 2,
      title: "Home Profile",
      heading: "Configure Your Detection System",
      description: "Users can create and manage their personal profiles with detailed information about their skin type, concerns, and medical history. This personalization helps the app provide more accurate recommendations and track progress over time.",
      subDescription: "The profile section allows users to upload photos, set reminders for treatments, and maintain a comprehensive record of their skincare journey, making it easier to share information with dermatologists during consultations.",
      image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img1.webp",
      reverse: true
    },
    {
      id: 3,
      title: "Consultation Screen",
      heading: "Monitor and Enforce Speed Limits Efficiently",
      description: "Book appointments with experienced Belgian dermatologists through the app's intuitive scheduling system. Get reliable advice within 48 hours and access professional guidance whenever you need it.",
      subDescription: "The consultation feature includes video calls, secure messaging, and the ability to share images of your skin concerns. All communications are encrypted and GDPR-compliant, ensuring your privacy and data security.",
      image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img1.webp",
      reverse: false
    }
  ];

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      
      <div className="container py-5">
        {features.map((feature, index) => (
          <div key={feature.id} className={`row align-items-center mb-5 ${index !== features.length - 1 ? 'pb-5' : ''}`}>
            {/* Image Section */}
            <div className={`col-md-6 ${feature.reverse ? 'order-md-2' : ''} mb-4 mb-md-0`}>
              <div className="position-relative d-flex justify-content-center">
                {/* Background Circle */}
                <div 
                  className="position-absolute rounded-circle"
                  style={{
                    width: '400px',
                    height: '400px',
                    background: 'linear-gradient(135deg, #e8ebff 0%, #f0f2ff 100%)',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 0
                  }}
                ></div>
                
                {/* Phone Mockup */}
                <div className="position-relative" style={{ zIndex: 1 }}>
                  <img 
                    src={feature.image}
                    alt={feature.title}
                    className="img-fluid"
                    style={{
                      maxWidth: '300px',
                      filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.1))'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Content Section */}
            <div className={`col-md-6 ${feature.reverse ? 'order-md-1 pe-md-5' : 'ps-md-5'}`}>
              <p 
                className="text-uppercase fw-semibold mb-3"
                style={{
                  color: '#6b7280',
                  fontSize: '0.875rem',
                  letterSpacing: '1px'
                }}
              >
                {feature.title}
              </p>
              
              <h2 
                className="fw-bold mb-4"
                style={{
                  fontSize: '2.5rem',
                  color: '#8b9bff',
                  lineHeight: '1.2'
                }}
              >
                {feature.heading}
              </h2>
              
              <p 
                className="mb-3"
                style={{
                  fontSize: '1.3rem',
                  color: '#374151',
                  lineHeight: '1.8'
                }}
              >
                {feature.description}
              </p>
              
              <p 
                className="mb-0"
                style={{
                  fontSize: '1.3rem',
                  color: '#374151',
                  lineHeight: '1.8'
                }}
              >
                {feature.subDescription}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}